var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bodyElement header"},[_c('h1',{staticClass:"bigTitle"},[_vm._v(_vm._s(_vm.$t("FederalView.bigTitle2")))])]),_c('div',{staticClass:"bodyElement"},[_c('ForecastGraph',{attrs:{"currentView":"FederalView"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }